<template>
  <div class="popup_base">
    <div class="popup" v-click-outside="closePopup">
      <h1>{{ item.name }}</h1>
      <div class="message">{{ t('移行するポイント数を入力してください。') }}</div>
      <div class="message center"><span class="point">{{ myPoint }}</span></div>
      <div class="box">
        <div class="row">
          <div class="label">{{t('ポイント')}}</div>
          <div class="text">
            <TextBox
              maxlength="10"
              inputType="number"
              @handleTextInput="changePoint($event)"
            />
          </div>
        </div>
      </div>
      <ErrorMessage
        v-if="errorMessage"
        class="error-message"
        :message="errorMessage"
      />
      <div class="button_area">
        <SquareButton
          class="square-button2"
          :text="t('ポイント移行')"
          :isMaxWidth="true"
          @handleSquareBtnClick="goToTransfer"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import {
  separateCharacterNumber,
} from '@/common/util/format';
import TextBox from '@/components/atoms/TextBox.vue';
import ErrorMessage from '@/components/atoms/ErrorMessage.vue';
import SquareButton from '@/components/atoms/SquareButton.vue';
import t from '@/plugins/i18n';

export default {
  name: 'SMSPopup',
  mixins: [t],

  components: {
    TextBox,
    ErrorMessage,
    SquareButton,
  },

  data: () => ({
    errorMessage: '',
    point: '',
  }),

  props: {
    item: {
      type: Object,
    },
  },

  computed: {
    ...mapGetters({
      resultTransfer: 'otherSite/resultTransfer',
      currentUser: 'user/currentUser',
    }),
    myPoint() {
      return separateCharacterNumber(this.currentUser.point);
    },
  },

  watch: {
    resultTransfer(newVal) {
      if (newVal.error !== '') {
        window.alert(this.t(newVal.error));
        this.$emit('closePopup');
      } else {
        this.$emit('pointSuccess');
      }
    },
  },

  methods: {
    goToTransfer() {
      if (parseInt(this.point, 10) <= 0) {
        window.alert(this.t('1ポイント以上で入力してください。'));
        return;
      }
      if (parseInt(this.point, 10) > parseInt(this.currentUser.point, 10)) {
        window.alert(this.t('所有ポイントをオーバーしています。'));
        return;
      }
      if (window.confirm(`${this.t(this.item.name)}${this.t('にポイントを移行しますか？')}`)) {
        const postParams = {
          point: this.point,
          site_id: this.item.id,
        };
        this.$store.dispatch('otherSite/transferPoint', { postParams });
      }
    },
    changePoint(value) {
      this.point = value;
    },
    changePassword(value) {
      this.password = value;
    },
    closePopup() {
      this.$emit('closePopup');
    },
  },
};
</script>

<style lang="scss" scoped>
.popup_base {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 10000;
  display: flex;
  justify-content: center;
  align-items: center;
  .popup {
    background-color: white;
    padding: 60px;
    border-radius: 10px;
    h1 {
      text-align: center;
    }
    .message {
      margin: 5px 0;
      span.point {
        font-size: 24px;
        margin-left: 10px;
        &:before {
          content: "P";
          width: 30px;
          height: 30px;
          border-radius: 100px;
          background-color: $deepGray;
          margin-right: 10px;
          color: $white;
          display: inline-flex;
          justify-content: center;
          align-items: center;
        }
      }
      &.center {
        text-align: center;
      }
    }
    .box {
      .row {
        width: 100%;
        margin: 5px 0;
        align-items: center;
        .label {
          width: 120px;
        }
        .text {
          width: calc(100% - 120px);
        }
      }
    }
    .button_area {
      display: flex;
      justify-content: center;
      margin-top: 10px;
      .square-button2 {
        width: 200px;
      }
    }
  }
}
@media screen and  (max-width: $tabletWidth) {
  .popup_base {
    .popup {
      padding: 20px;
    }
  }
}
</style>
